import { useEffect, useState } from "react";
import axios from "axios";
import PLAN_URL from "../../../utils/PLAN_URL";

export function useInsightwinProcessMaster(
  clickedProcId,
  group_code,
  project_code
) {
  const [processMasterData, setProcessMasterData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(
          PLAN_URL +
            `/api/proc/getProcM?group_code=${group_code}&project_code=${project_code}`
        );
        const res2 = await axios.get(
          PLAN_URL +
            `/api/orders/getAllOrder?group_code=${group_code}&project_code=${project_code}`
        );
        setProcessMasterData(res.data);
        setOrderData(res2.data);
      } catch (e) {
        console.log(e);
      }
    }
    fetchData();
  }, [clickedProcId]);
  return {
    processMasterData,
    orderData,
  };
}
